export const ONLINE_TARIFF_TEXT = "Онлайн-консультация";
export const OFFLINE_TARIFF_TEXT = "Прием в клинике";
export const CODE_CONFIRM_EMAIL_MSG =
  "Для подтверждения изменения %s необходимо ввести код из письма, отправленного на e-mail";
export const CODE_CONFIRM_SMS_MSG =
  "Для подтверждения изменения %s необходимо ввести код из СМС, отправленного на номер телефона";
export const CODE_CONFIRM_EMAIL_TITLE = "Изменение электронной почты";
export const CODE_CONFIRM_SMS_TITLE = "Изменение номера телефона";
export const PROFILE_CHANGE_SETTINGS_VIEW = "profileChangeSettings";
